// extracted by mini-css-extract-plugin
export default {"rowContainerCenter":"styles_rowContainerCenter__HxVmN","colContainerCenter":"styles_colContainerCenter__Hn16c","btn":"styles_btn__S1wDm"};